export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-3 0h16v16H-3z\"/><path d=\"M3 16a.334.334 0 01-.323-.414L4.24 9.333H1a.334.334 0 01-.284-.508L6.049.158a.333.333 0 01.608.256L5.094 6.667h3.24a.334.334 0 01.283.508l-5.333 8.667A.334.334 0 013 16zM1.597 8.667h3.07a.333.333 0 01.323.414l-1.143 4.574 3.89-6.322h-3.07a.333.333 0 01-.324-.414l1.144-4.574z\" fill=\"#3F4450\" fill-rule=\"nonzero\"/></g>",
  "attrs": {
    "height": "16",
    "viewBox": "0 0 9 16",
    "width": "9",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};